module.exports = __webpack_public_path__ + "img/fondo2.9554e7e4.png";